import { request } from '@/shared/api/request'

export const getPage = (params) => {
	return request({ url: 'colcontract/industryAgreement/page', method: 'POST', params: params })
}
